import React, { Fragment, useState, useEffect } from 'react';
import { API_URL } from '../../../config';
// import { Link } from 'react-router-dom';
import { Form, Field, FormRenderProps } from 'react-final-form';
import { Country } from "../../../models/Country";
import { FormErrors } from "../../../models/FormErrors";

export interface InterestFormProps {
    page: string;
}

interface InterestFormValues {
    name: string;
    email: string;
    areaCode: string;
    phone: string;
    country: number;
    propertyName?: string;
    city?: string;
    postCode?: string;
    street?: string;
    propertyCountry?: number;
    price?: string;
    morgage?: 'yes' | 'no';
    listed?: 'yes' | 'no';
    saleType?: 'part' | 'all';
    percentage?: string;
}

export const InterestForm: React.FC<InterestFormProps> = ({ page }) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [success, setSuccess] = useState(false);
    const [countries, setCountries] = useState<Country[]>([]);

    useEffect(() => {
        fetch(API_URL + "countries").then(
            res => {
                return res.json();
            }
        ).then(res => {
            setCountries(res);
        });
    }, []);

    const validateEmail = (email: string): boolean => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) !== null;
    };

    const onSubmit = async (values: InterestFormValues): Promise<void> => {
        console.log('Submit', values);
        const formData = new FormData();

        for (const key in values) {
            if (values.hasOwnProperty(key)) {
                formData.append(key, values[key]);
            }
        }

        fetch(API_URL + 'interest', {
            method: 'POST',
            body: formData,
        })
            .then((response) => response.json())
            .then((response) => {
                if (response?.status !== 'ok') {
                    setSuccess(false);
                    setErrors(response);
                } else {
                    setErrors([]);
                    setSuccess(true);
                }
            });
    };

    return (
        <Fragment>
            {errors.length > 0 && (
                <div className="alert alert-danger" role="alert">
                    {errors.map((error, index) => (
                        <span key={`error${index}`}>{error}</span>
                    ))}
                </div>
            )}
            {success && (
                <div className="alert alert-success" role="alert">
                    Let’s get <i>nfty</i>
                    <br />
                    <br />
                    You’re a pioneer! Welcome to the family.. We’ll be in touch just as soon as we can help get you up and running.
                </div>
            )}
            <Form
                validate={(values: InterestFormValues) => {
                    const requiredFields = [
                        'name',
                        'areaCode',
                        'email',
                        'phone',
                    ];

                    if (page === 'sell') {
                        requiredFields.push('city');
                        requiredFields.push('postCode');
                        requiredFields.push('street');
                        requiredFields.push('price');
                    }

                    const errors: Partial<FormErrors> = {};

                    requiredFields.forEach((field) => {
                        if (!values[field]) {
                            errors[field] = 'Required';
                        }
                    });

                    if (!values?.email) {
                        errors.email = 'Required';
                    } else if (!validateEmail(values.email as string)) {
                        errors.email = 'Invalid e-mail';
                    }

                    return errors;
                }}
                onSubmit={onSubmit}
                render={({ handleSubmit, submitting, pristine, values }: FormRenderProps<InterestFormValues>) => (
                    <form onSubmit={handleSubmit}>
                        <h2 style={{ textAlign: 'center', paddingBottom: '15px' }}>Personal Info</h2>

                        <Field name="name">
                            {({ input, meta }) => (
                                <div>
                                    <div className="popup-sign-item">
                                        <label htmlFor="name">Full name {meta.error && meta.touched && <span style={{ color: 'red' }}>{meta.error}</span>}</label>
                                        <input {...input} type="text" className="form-value-color" id="asif-pl" placeholder="" />
                                    </div>
                                </div>
                            )}
                        </Field>

                        <Field name="email">
                            {({ input, meta }) => (
                                <div>
                                    <div className="popup-sign-item">
                                        <label htmlFor="email">Email {meta.error && meta.touched && <span style={{ color: 'red' }}>{meta.error}</span>}</label>
                                        <input {...input} type="email" className="form-value-color" id="asif-pl" placeholder="" />
                                    </div>
                                </div>
                            )}
                        </Field>

                        <div className="row g-2">
                            <div className="col-4">
                                <Field name="areaCode">
                                    {({ input, meta }) => (
                                        <div className="popup-sign-item">
                                            <label htmlFor="name">Area code {meta.error && meta.touched &&
                                                <span style={{ color: 'red' }}>{meta.error}</span>}</label>
                                            <div className="popup-pass-show">
                                                <input {...input} type="text" name="text" placeholder="" />
                                            </div>
                                        </div>
                                    )}
                                </Field>
                            </div>
                            <div className="col-8">
                                <Field name="phone">
                                    {({ input, meta }) => (
                                        <div className="popup-sign-item">
                                            <label htmlFor="phpne">Phone {meta.error && meta.touched &&
                                                <span style={{ color: 'red' }}>{meta.error}</span>}</label>
                                            <div className="popup-pass-show">
                                                <input {...input} type="text" name="text" placeholder="" />
                                            </div>
                                        </div>
                                    )}
                                </Field>
                            </div>
                        </div>

                        <Field name="country"
                            initialValue="">
                            {({ input, meta }) => (
                                <div className="popup-sign-item">
                                    <label>Country {meta.error && meta.touched &&
                                        <span style={{ color: 'red' }}>{meta.error}</span>}</label>
                                    <select {...input}>
                                        <option value="" disabled>Select a country</option>
                                        {countries.map(country =>
                                            (<option key={"country" + country.id} value={country.id}>{country.name}</option>)
                                        )}
                                    </select>
                                </div>
                            )}
                        </Field>

                        {page === 'sell' &&
                            <Fragment>
                                <h2 style={{ textAlign: 'center', paddingBottom: '15px' }}>Property Info</h2>

                                <Field name="propertyName">
                                    {({ input, meta }) => (
                                        <div>
                                            <div className="popup-sign-item">
                                                <label htmlFor="propertyName">Property name {meta.error && meta.touched &&
                                                    <span style={{ color: 'red' }}>{meta.error}</span>}</label>
                                                <input {...input} type="text" className="form-value-color" id="asif-pl" placeholder="" />
                                            </div>
                                        </div>
                                    )}
                                </Field>

                                <Field name="city">
                                    {({ input, meta }) => (
                                        <div>
                                            <div className="popup-sign-item">
                                                <label htmlFor="city">Town/City {meta.error && meta.touched &&
                                                    <span style={{ color: 'red' }}>{meta.error}</span>}</label>
                                                <input {...input} type="text" className="form-value-color" id="asif-pl" placeholder="" />
                                            </div>
                                        </div>
                                    )}
                                </Field>

                                <div className="row g-2">
                                    <div className="col-4">
                                        <Field name="postCode">
                                            {({ input, meta }) => (
                                                <div className="popup-sign-item">
                                                    <label htmlFor="name">Post code {meta.error && meta.touched &&
                                                        <span style={{ color: 'red' }}>{meta.error}</span>}</label>
                                                    <div className="popup-pass-show">
                                                        <input {...input} type="text" name="text" placeholder="" />
                                                    </div>
                                                </div>
                                            )}
                                        </Field>
                                    </div>
                                    <div className="col-8">
                                        <Field name="street">
                                            {({ input, meta }) => (
                                                <div className="popup-sign-item">
                                                    <label htmlFor="street">Street {meta.error && meta.touched &&
                                                        <span style={{ color: 'red' }}>{meta.error}</span>}</label>
                                                    <div className="popup-pass-show">
                                                        <input {...input} type="text" name="text" placeholder="" />
                                                    </div>
                                                </div>
                                            )}
                                        </Field>
                                    </div>
                                </div>

                                <Field name="propertyCountry"
                                    initialValue="">
                                    {({ input, meta }) => (
                                        <div className="popup-sign-item">
                                            <label>Country {meta.error && meta.touched &&
                                                <span style={{ color: 'red' }}>{meta.error}</span>}</label>
                                            <select {...input}>
                                                <option value="" disabled>Select a country</option>
                                                {countries.map(country =>
                                                    (<option key={"country" + country.id} value={country.id}>{country.name}</option>)
                                                )}
                                            </select>
                                        </div>
                                    )}
                                </Field>

                                <Field name="price">
                                    {({ input, meta }) => (
                                        <div>
                                            <div className="popup-sign-item">
                                                <label htmlFor="city">Asking price {meta.error && meta.touched &&
                                                    <span style={{ color: 'red' }}>{meta.error}</span>}</label>
                                                <input {...input} type="text" className="form-value-color" id="asif-pl" placeholder="" />
                                            </div>
                                        </div>
                                    )}
                                </Field>

                                <Field name="morgage" initialValue={'no'}>
                                    {({ input, meta }) => (
                                        <div className="popup-sign-item">
                                            <label>Is there a morgage</label>
                                            <select {...input}>
                                                <option value={'yes'}>Yes</option>
                                                <option value={'no'}>No</option>
                                            </select>
                                        </div>
                                    )}
                                </Field>

                                <Field name="listed" initialValue={'no'}>
                                    {({ input, meta }) => (
                                        <div className="popup-sign-item">
                                            <label>Is the propery currently listed?</label>
                                            <select {...input}>
                                                <option value={'yes'}>Yes</option>
                                                <option value={'no'}>No</option>
                                            </select>
                                        </div>
                                    )}
                                </Field>

                                <Field name="saleType" initialValue={'all'}>
                                    {({ input, meta }) => (
                                        <div className="popup-sign-item">
                                            <label>Do you want to sell part ot all of the propery?</label>
                                            <select {...input}>
                                                <option value={'part'}>Part</option>
                                                <option value={'all'}>All</option>
                                            </select>
                                        </div>
                                    )}
                                </Field>

                                {values.saleType === 'part' &&
                                    <Field name="percentage">
                                        {({ input, meta }) => (
                                            <div>
                                                <div className="popup-sign-item">
                                                    <label htmlFor="city">Percentage you want to sell {meta.error && meta.touched &&
                                                        <span style={{ color: 'red' }}>{meta.error}</span>}</label>
                                                    <input {...input} type="text" className="form-value-color" id="asif-pl" placeholder="" />
                                                </div>
                                            </div>
                                        )}
                                    </Field>
                                }

                            </Fragment>
                        }

                        <div className="popup-sign-in-submite wcl-btn">
                            <button type="submit">Apply</button>
                        </div>
                    </form>
                )}
            />
        </Fragment>
    );
};